import React from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRoutePropos,
  Redirect,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRoutePropos {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { customer } = useAuth();
  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!customer ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/informacoes-basicas',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
